<template>
  <div class="full-screen-div flex flex-col justify-start items-center">
    <div
      class="dashboard_navbar max-w-7xl w-full items-center flex flex-row justify-between lg:px-12 md:px-4 px-3 py-4"
    >
      <div
        class="flex justify-start items-center md:gap-4 gap-2 flex-1 min-w-0"
      >
        <img
          src="@/assets/images/logot.svg"
          class="md:w-24 md:h-24 w-14 h-14 cursor-pointer md:mr-10 mr-1 flex-shrink-0"
          @click="redirectHome"
        />
        <div
          class="text-white flex flex-col justify-center md:h-24 h-14 min-w-0"
        >
          <p class="welcome_msg md:text-2xl text-base font-bold truncate">
            //Welcome
            <span v-if="activeUserInfo.firstName" class="text-primary"
              >{{ cropMiddleToLength(activeUserInfo.firstName, 12) }}!</span
            >
            <span v-else class="text-primary">to Decast!</span>
          </p>
          <p
            class="text-lg md:block hidden"
            style="color: #22c55e; flex-wrap: nowrap"
          >
            /* what are we starting today? */
          </p>
        </div>
      </div>

      <div
        class="flex flex-row md:gap-6 gap-2 justify-end md:h-24 h-14 items-center flex-shrink-0"
      >
        <!-- <div v-if="accessToken && activeUserInfo.provider == 'wallet'" class="flex gap-6">
          <img src="@/assets/images/pixel_wallet.svg" class="w-8 h-6 cursor-pointer" />
          <p class="text-lg">{{ cropMiddleToLength(activeUserInfo.firstName, 12) }}!</p>
        </div>
        <div v-else-if="accessToken && activeUserInfo.provider == 'email'" class="flex gap-2">
          <img src="@/assets/images/pixel_email.svg" class="w-8 h-6 cursor-pointer" />
          <p class="text-lg">{{ activeUserInfo.email }}</p>
        </div> -->
        <!-- <img src="@/assets/images/pixel_smile.svg" class="w-12 h-12 cursor-pointer" /> -->
        <div class="">
          <div v-if="accessToken || loggedIn">
            <SimpleMenu :menuList="profileMenuItems">
              <template #menuButton>
                <div class="pfp">
                  <!-- <vs-avatar :text="getFirstLetter" color="primary" class="m-0 shadow-md"
                    :src="activeUserInfo.profile_pic ? activeUserInfo.profile_pic : ''" size="40px" /> -->
                  <vs-avatar
                    :text="getFirstLetter"
                    color="primary"
                    class="m-0 shadow-md"
                    :src="
                      activeUserInfo.profile_pic ||
                      require('@/assets/images/user-icon-placeholder.png')
                    "
                    size="40px"
                  />
                </div>
              </template>
            </SimpleMenu>
          </div>
          <button v-else class="butt cursor-pointer" @click="open">
            Login
          </button>
        </div>
      </div>
    </div>

    <div
      v-if="accessToken || loggedIn"
      class="dashboard_banner max-w-7xl w-full lg:px-12 md:px-4 px-3"
    >
      <UsageBanner />
    </div>

    <div
      class="dashboard_content max-w-7xl w-full flex md:flex-row flex-col gap-3 justify-start lg:px-12 md:px-4 px-3 md:py-4 py-2"
    >
      <div
        class="dash-sidenav flex md:flex-col flex-row justify-start md:gap-4 gap-2 md:mr-10 mr-0 md:overflow-visible overflow-x-auto md:pb-0 pb-2"
      >
        <vx-tooltip text="/ Rooms" position="right">
          <div
            class="md:w-24 md:h-24 w-16 h-16 flex-shrink-0 cursor-pointer flex flex-col items-center justify-center md:gap-2 gap-1"
            @click="onRoom"
            :class="{ calls_btn_: true, calls_clicked: isClicked1 }"
          >
            <img :src="callSrc" alt="Image" />
            <p class="font-semibold md:text-base text-xs">CALLS</p>
          </div>
        </vx-tooltip>

        <vx-tooltip text="/ Casts" position="right">
          <div
            class="md:w-24 md:h-24 w-16 h-16 flex-shrink-0 cursor-pointer flex flex-col items-center justify-center md:gap-2 gap-1"
            @click="onCasts"
            :class="{ casts_btn: true, cast_clicked: isClicked2 }"
          >
            <img :src="castSrc" alt="Image" />
            <p class="font-semibold md:text-base text-xs">CASTS</p>
          </div>
        </vx-tooltip>

        <vx-tooltip text="/ Decast" position="right">
          <div
            class="md:w-24 md:h-24 w-16 h-16 flex-shrink-0 cursor-pointer flex flex-col items-center justify-center md:gap-2 gap-1"
            @click="onDecasts"
            :class="{ decast_btn: true, decast_clicked: isClicked3 }"
          >
            <img :src="decastSrc" alt="Image" />
            <p class="font-semibold md:text-base text-xs">DECAST</p>
          </div>
        </vx-tooltip>

        <!-- <vx-tooltip text="/ Contact" position="right">
          <div class="md:w-24 md:h-24 w-16 h-16 flex-shrink-0 cursor-pointer flex flex-col items-center justify-center md:gap-2 gap-1" @click="onContact"
            :class="{ 'contact_btn': true, 'contact_clicked': isClicked5 }">
            <img class="object-fit w-12 h-12" :src="contactSrc" alt="Image">
            <p class="font-semibold md:text-base text-xs">CONTACTS</p>
          </div>
        </vx-tooltip> -->

        <UsageTile v-if="accessToken || loggedIn" />

        <vx-tooltip text="/ Storages" position="right">
          <div
            class="md:w-24 md:h-24 w-16 h-16 flex-shrink-0 cursor-pointer flex flex-col items-center justify-center md:gap-2 gap-1"
            @click="onStorages"
            :class="{ storage_btn: true, storage_clicked: isClicked4 }"
          >
            <img class="object-fit w-12 h-12" :src="storageSrc" alt="Image" />
            <p class="font-semibold md:text-base text-xs">STORAGES</p>
          </div>
        </vx-tooltip>
      </div>

      <div class="w-full flex flex-col justify-start gap-2">
        <div>
          <router-view />
        </div>
      </div>
    </div>
    <ResetPasswordModal
      v-if="activeModal === 'resetPassModal'"
      :toggleActiveModal="toggleActiveModal"
    />
    <ProfileModal
      v-if="activeModal === 'profileModal'"
      :toggleActiveModal="toggleActiveModal"
    />
  </div>
</template>

<script>
import RoomSection from './rooms/RoomSection.vue';
import CastSection from './casts/CastSection.vue';
import DecastSection from './decast/DecastSection.vue';
import constants from '../../../constant';
import { utils } from '@/mixins/index';
import SimpleMenu from '@/components/common/simpleMenu/SimpleMenu.vue';
import UsageBanner from './components/UsageBanner.vue';
import UsageTile from './components/UsageTile.vue';
import { resetAccount } from '@/http/requests/account';
import ResetPasswordModal from '@/views/dashboard/components/ResetPasswordModal';
import ProfileModal from '@/views/dashboard/components/ProfileModal';
import callIcon from '@/assets/images/call-icon.svg';
import callIconAlt from '@/assets/images/call-icon-alt.svg';
import castIcon from '@/assets/images/cast-icon.svg';
import castIconAlt from '@/assets/images/cast-icon-alt.svg';
import decastIcon from '@/assets/images/decast-icon.svg';
import decastIconAlt from '@/assets/images/decast-icon-alt.svg';
import storageIcon from '@/assets/images/storage_black.png';
import storageIconAlt from '@/assets/images/storage_white.png';
import contactIcon from '@/assets/images/contact.svg';
import contactIconAlt from '@/assets/images/contact-alt.svg';

export default {
  name: 'Dashboard',
  components: {
    RoomSection,
    CastSection,
    DecastSection,
    SimpleMenu,
    UsageBanner,
    UsageTile,
    ResetPasswordModal,
    ProfileModal,
  },
  data() {
    return {
      focusYourRooms: true,
      showRoomSection: true,
      showCastSection: false,
      showCommunitySection: false,
      rooms: true,
      casts: false,
      decasts: false,
      storages: false,
      activeModal: '',
      offset: 0,
      url: '/v2login',
      iframe: false,
      userMenuVisible: false,
      profileMenuItems: [
        {
          label: 'My Profile',
          icon: () => import('@/assets/svgs/menu-icons/usermenu.vue'),
          onClick: () => this.$router.push('/profile'),
        },
        {
          label: 'Plan & Usage',
          icon: () => import('@/assets/svgs/menu-icons/wallet.vue'),
          onClick: () => this.$router.push('/dashboard/account'),
        },
        {
          label: '2FA',
          icon: () => import('@/assets/svgs/menu-icons/setting.vue'),
          onClick: () => this.configure2fa(),
        },
        {
          label: 'Reset Password',
          icon: () => import('@/assets/svgs/menu-icons/setting.vue'),
          onClick: () => this.toggleActiveModal('resetPassModal'),
        },
        {
          label: 'Wallet',
          icon: () => import('@/assets/svgs/menu-icons/wallet.vue'),
          onClick: () => this.$router.push('/addfunds'),
        },
        // {
        //   label: "Help Center",
        //   icon: () => import("@/assets/svgs/menu-icons/help.vue"),
        // },
        {
          label: 'Logout',
          icon: () => import('@/assets/svgs/menu-icons/export.vue'),
          onClick: () => {
            this.$cookies.remove('userId');
            this.$cookies.remove('Token');
            this.$router.push('/');
            resetAccount();
            return this.$store.dispatch('auth/v2logOut');
          },
        },
      ],
    };
  },
  computed: {
    /** Which section the route is in. Everything the rail draws follows from this. */
    section() {
      const path = this.$route.path;
      if (path.startsWith('/dashboard/rooms')) return 'rooms';
      if (path.startsWith('/dashboard/casts')) return 'casts';
      if (path.startsWith('/dashboard/decast')) return 'decast';
      if (path.startsWith('/dashboard/storage')) return 'storage';
      if (path.startsWith('/dashboard/contact')) return 'contact';
      if (path.startsWith('/dashboard/account')) return 'account';
      return '';
    },
    isClicked1() {
      return this.section === 'rooms';
    },
    isClicked2() {
      return this.section === 'casts';
    },
    isClicked3() {
      return this.section === 'decast';
    },
    isClicked4() {
      return this.section === 'storage';
    },
    isClicked5() {
      return this.section === 'contact';
    },
    // the selected tile shows the solid icon, the rest the outlined one
    callSrc() {
      return this.isClicked1 ? callIcon : callIconAlt;
    },
    castSrc() {
      return this.isClicked2 ? castIcon : castIconAlt;
    },
    decastSrc() {
      return this.isClicked3 ? decastIcon : decastIconAlt;
    },
    storageSrc() {
      return this.isClicked4 ? storageIcon : storageIconAlt;
    },
    contactSrc() {
      return this.isClicked5 ? contactIcon : contactIconAlt;
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    accessToken() {
      return this.$store.state.auth.accessToken;
    },
    loggedIn() {
      return this.$store.state.auth.loggedIn;
    },
    getFirstname() {
      return this.activeUserInfo.firstName;
    },
    getFirstLetter() {
      return this.activeUserInfo?.firstName?.[0] || 'D';
    },
  },
  mounted() {
    document.body.classList.add('dash-dark-body');
    const gb_redirect = localStorage.getItem('LOG_REDIRECT');
    if (gb_redirect) {
      localStorage.removeItem('LOG_REDIRECT');
      const url = new URL(gb_redirect);
      const path = url.pathname + url.search + url.hash; // Extract path, query, and hash
      this.$router.push(path);
    }
    this.verifyAuthToken();
    // this.userInfo = { ...this.$store.state.AppActiveUser };
    // this.$store.commit('UPDATE_USER_INFO', this.userInfo);
    // this.onRoom();
  },
  beforeDestroy() {
    document.body.classList.remove('dash-dark-body');
  },
  methods: {
    configure2fa() {
      this.$router.push({ name: 'Configure 2fa' });
    },
    verifyAuthToken() {
      this.$store.dispatch('auth/v2verifyAuthToken');
    },
    toggleActiveModal(setModal) {
      this.activeModal = setModal;
    },
    scroll(offset) {
      this.offset = offset;
    },
    closeIframe() {
      var iframe = document.getElementById('myIframe');
      iframe.style.display = 'none';
    },
    open() {
      this.$router.push('/v2login');
    },
    toggleUserMenu() {
      console.log('Clicked');
      this.userMenuVisible = !this.userMenuVisible;
    },
    redirectHome() {
      this.$router.push('/');
    },

    changeFocus(toYourRooms) {
      this.focusYourRooms = toYourRooms;
    },
    onRoom() {
      this.$router.push('/dashboard/rooms');
    },

    onCasts() {
      this.$router.push('/dashboard/casts');
    },

    onDecasts() {
      this.$router.push('/dashboard/decast');
    },
    onContact() {
      this.$router.push('/dashboard/contact');
    },

    onStorages() {
      this.$router.push('/dashboard/storage');
    },

    cropMiddleToLength(id, maxLength = 12, mask = '***') {
      const chars = Array.from(String(id || ''));
      if (chars.length <= maxLength) return chars.join('');
      const keep = maxLength - mask.length;
      const start = Math.ceil(keep / 2);
      const end = Math.floor(keep / 2);
      return chars.slice(0, start).join('') + mask + chars.slice(-end).join('');
    },
  },
};
</script>

<style>
/* applied to <body> while the dashboard is mounted, so no wrapper mis-sizing
   can ever expose the white document background beneath the dark canvas */
body.dash-dark-body {
  background: #0a0b0f;
}
</style>

<style scoped>
* {
  font-family: 'JetBrains Mono', monospace !important;
}

.full-screen-div {
  width: 100%;
  /* grow with content: with the mobile columns stacked the page is taller
     than the viewport, and a fixed height left white body showing below */
  min-height: 100vh;
  height: auto;
  background: #0a0b0f;
  color: white;
}

.dashboard_navbar {
  min-height: 16vh;
}

.dashboard_content {
  min-height: 70vh;
  flex: 1;
}

.basic_details_cont {
  /* border: 1px solid white;
  height: 70vh; */
}

.options-button {
  background: none;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
}

.focused-button {
  color: #d7df23;
}

.con-vs-tooltip {
  border-radius: 0px !important;
  /* border: 1px solid red; */
  color: #0a0b0f !important;
}

.calls_btn_ {
  background-color: black;
  border: 1px solid white;
  color: white;
}

.calls_clicked {
  background-color: white;
  color: black;
}

.casts_btn {
  background-color: black;
  border: 1px solid white;
  color: white;
}

.cast_clicked {
  background-color: white;
  color: black;
}

.decast_btn {
  background-color: black;
  border: 1px solid white;
  color: white;
}

.decast_clicked {
  background-color: white;
  color: black;
}

.storage_btn {
  background-color: black;
  border: 1px solid white;
  color: white;
}

.storage_clicked {
  background-color: white;
  color: black;
}

.contact_btn {
  background-color: black;
  border: 1px solid white;
  color: white;
}

.contact_clicked {
  background-color: white;
  color: black;
}

/* dash mobile pass */
@media (max-width: 767px) {
  /* vx-tooltip wraps each tile; without this the wrappers flex-shrink and
     the tiles get clipped */
  .dash-sidenav > * {
    flex: 0 0 auto;
  }
  .dash-sidenav {
    min-height: 76px;
    align-items: center;
  }
  .dash-sidenav img {
    width: 26px !important;
    height: 26px !important;
    object-fit: contain;
  }
  .dash-sidenav::-webkit-scrollbar {
    display: none;
  }
}
</style>
